import Icon from "./Icon";
import { hostname } from "../services/configServices/config";

const UserAvatar = ({
  className = "",
  icon,
  image,
  imageAlt,
  text,
  children,
}) => {
  return (
    <div
      className={`w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center ${className}`}
    >
      {icon ? (
        <Icon icon={icon} className="text-primary-light text-xl" />
      ) : null}
      {image && (
        <img className="rounded-circle" src={hostname + image} alt={imageAlt} />
      )}
      {text && !image && <span>{text}</span>}
      {children}
    </div>
  );
};

export default UserAvatar;
